import angular from 'angular';
import { URL_SIGN_IN } from 'common';

import SignInComponent from './sign-in.cmpt';

export default angular
    .module('application.scene.identity.scene.sign-in', [])
    .component(SignInComponent.selector, SignInComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.sign-in', {
        url: URL_SIGN_IN,
        template: '<db-a-sign-in class="block-component"></db-a-sign-in>',
        params: {
            error: null
        },
        data: {
            requires: {
                anonymous: 'authorized.calendar'
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/sign-in/index.js